import { render, staticRenderFns } from "./WarningMessage.vue?vue&type=template&id=ed8c937e&"
import script from "./WarningMessage.vue?vue&type=script&lang=js&"
export * from "./WarningMessage.vue?vue&type=script&lang=js&"
import style0 from "./WarningMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports